module.exports = __webpack_public_path__ + "img/2024.d2a53500.svg";